import styled, { css } from 'styled-components';

export const TableRow = styled.tr`
  text-align: center;
  &:nth-child(odd) {
    border: 1px solid #dee2e6;
    border-color: #fbfcfc;
    background-color: rgb(240 240 241);
  }
  &:nth-child(even) {
    border: 1px solid #dee2e6;
    border-color: #fbfcfc;
    background-color: #fff;
  }
  ${(props) =>
    props.isSelectedRow &&
    css`
      &:hover {
        color: #295c88 !important;
        cursor: pointer;
      }
    `}
  ${(props) =>
    props.isHeading &&
    css`
      background-color: #fff !important;
    `}

    ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const Table = styled.table`
  font-weight: 400 !important;
  font-size: 14px;
  border: 2px solid #dee2e6;
  background: white;
  margin: ${(props) => (props.margin ? props.margin : '0px')};
`;

export const TableHeading = styled.th`
  ${(props) =>
    props.hideOnSmallDevice &&
    css`
      @media (max-width: 736px) {
        display: none;
      }
    `}
`;

export const TableHead = styled.thead``;

export const TableData = styled.td`
  border: 1px solid #dee2e6;
  padding: 0.75rem;

  img {
    @media (min-width: 1366px) {
      max-width: 60%;
    }
  }

  ${(props) =>
    props.hideOnSmallDevice &&
    css`
      @media (max-width: 736px) {
        display: none;
      }
    `}

  ${(props) =>
    props.alignLeft &&
    css`
      text-align: left;
    `}

    ${(props) =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth};
    `}

    ${(props) =>
    props.isFeedbackRow &&
    css`
      overflow-wrap: break-word;
      max-width: 200px;
    `}
`;

export const TableBody = styled.tbody`
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
`;

export const SortArrowImage = styled.img`
  height: 10px;
  width: 10px;
  margin-left: 5px;
  cursor: pointer;
`;

export const RankListContainer = styled.div`
  width: 100%;
`;
